export default "__VITE_ASSET__9873742a__"